import { ObservableFromFetch } from "../ObservableFromFetch"
import LocationExists from "./LocationModel/LocationExists"

export function CheckLocationName(companyID: number, name: string) {
  const requestBody: string = JSON.stringify({
    CompanyID: companyID,
    Name: name
  })

  return ObservableFromFetch<LocationExists>("FFOrderClientFileMaintenance/LocationExists", requestBody)
}

export function CheckLocationCode(companyID: number, code: string) {
  const requestBody: string = JSON.stringify({
    CompanyID: companyID,
    Name: code
  })

  return ObservableFromFetch<LocationExists>("FFOrderClientFileMaintenance/LocationCodeExists", requestBody)
}
